import { useState } from "react";
import axios from "axios";
import { Phone, Mail, MapPin } from "lucide-react";
import { toast } from "sonner";
import AnimatedSection from "@/utils/AnimatedSection";
import { API } from "@/utils/constants";

const contactInfo = [
  { icon: Phone, label: "+91 8985709090", gradient: "icon-teal" },
  { icon: Phone, label: "+91 8985709595", gradient: "icon-teal" },
  { icon: Mail, label: "info@tots360.in", gradient: "icon-coral" },
  { icon: MapPin, label: "2nd Floor, Fairmount Fortune One, Czech Colony, Sanath Nagar, Hyderabad, Telangana 500018", gradient: "icon-purple" },
];

const Contact = ({ theme }) => {
  const [form, setForm] = useState({ parent_name: "", child_name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Thank you! We'll contact you soon.");
      setForm({ parent_name: "", child_name: "", email: "", phone: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  return (
    <section id="contact" className="py-24 relative overflow-hidden bg-mesh" data-testid="contact-section">
      <div className="orb orb-coral w-[400px] h-[400px] -bottom-40 right-0" />
      <div className="orb orb-purple w-[300px] h-[300px] top-20 -left-20" />
      
      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12">
          <AnimatedSection>
            <span className="badge-glass inline-flex px-3 py-1 rounded-full text-xs font-medium text-[#4ECDC4] mb-4">
              Contact Us
            </span>
            <h2 className="font-display text-4xl md:text-5xl text-primary mb-6">Book a Screening</h2>
            <p className="text-secondary text-lg leading-relaxed mb-10">
              Take the first step towards comprehensive health intelligence for your child.
            </p>

            <div className="space-y-4">
              {contactInfo.map((item, i) => (
                <div key={i} className="glass flex items-center gap-4 p-4 rounded-xl">
                  <div className={`w-11 h-11 rounded-xl ${item.gradient} flex items-center justify-center shadow-lg`}>
                    <item.icon className="w-5 h-5 text-white" />
                  </div>
                  <span className="font-medium text-primary">{item.label}</span>
                </div>
              ))}
            </div>
          </AnimatedSection>

          <AnimatedSection delay={0.2}>
            <form onSubmit={submit} className="glass-strong p-8 rounded-3xl" data-testid="contact-form">
              <div className="grid md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-sm font-medium mb-2 text-white/80">Parent's Name</label>
                  <input type="text" value={form.parent_name} onChange={(e) => setForm({ ...form, parent_name: e.target.value })} className="glass-input w-full px-4 py-3" placeholder="Your name" required data-testid="input-parent-name" />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2 text-white/80">Child's Name</label>
                  <input type="text" value={form.child_name} onChange={(e) => setForm({ ...form, child_name: e.target.value })} className="glass-input w-full px-4 py-3" placeholder="Child's name" required data-testid="input-child-name" />
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-sm font-medium mb-2 text-white/80">Email</label>
                  <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="glass-input w-full px-4 py-3" placeholder="you@email.com" required data-testid="input-email" />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2 text-white/80">Phone</label>
                  <input type="tel" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="glass-input w-full px-4 py-3" placeholder="+91 98765 43210" required data-testid="input-phone" />
                </div>
              </div>
              <div className="mb-6">
                <label className="block text-sm font-medium mb-2 text-white/80">Message (Optional)</label>
                <textarea value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="glass-input w-full px-4 py-3 resize-none" rows={3} placeholder="Any specific concerns?" data-testid="input-message" />
              </div>
              <button type="submit" disabled={loading} className="w-full btn-coral py-4 rounded-xl font-semibold transition-all disabled:opacity-50" data-testid="contact-submit-button">
                {loading ? "Submitting..." : "Request Appointment"}
              </button>
            </form>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default Contact;
